/* @flow */
import React from 'react';
import BoxBody from 'components/BoxBody.jsx';
import BoxHeader from 'components/BoxHeader.jsx';
import Input from 'components/Input.jsx';
import Image from 'components/Image.jsx';
import Group from 'entities/Group';
import Text from 'components/Text.jsx';
import CurrentUser from 'auth/CurrentUser';

import './styles/SmsInstruction.scss';

class SmsInstruction extends React.Component {
  static propTypes = {
    group: React.PropTypes.instanceOf(Group).isRequired,
  };

  render() {
    const { group } = this.props;
    const inputId = 'SmsInstruction-phone-input';

    let number;
    if (CurrentUser.isSignedIn()) {
      number = !group.useShortCodeForUser(CurrentUser.getUser()) &&
      group.getSMSAlternateNumber() ?
        group.getSMSAlternateNumber() :
        group.getSMSNumber();
    } else {
      number = !(group.getSubscriptionInfo().sms && group.hasShortCode()) &&
      group.getSMSAlternateNumber() ?
        group.getSMSAlternateNumber() :
        group.getSMSNumber();
    }
    const code = group.getCode();

    const title = (
      <span>
        Tell people to text @{code} to the number {number}
      </span>
    );

    const alternateNumber = group.getSMSAlternateNumber();

    const subtext = (
      <span>
        They’ll receive a welcome text from Remind.
        {
          alternateNumber &&
            <Text>
              <br />
              If anyone has trouble with {number},{' '}
              they can try texting @{code} to {alternateNumber}.
            </Text>
        }
      </span>
    );

    return (
      <div className="SmsInstruction">
        <BoxHeader title={title} subtext={subtext} />
        <BoxBody>
          <div className="SmsInstruction-phone">
            <Image
              className="SmsInstruction-phone-image"
              src={require('assets/images/GroupInviteModal/phone.svg')}
            />

            <div className="SmsInstruction-phone-to">
              <div className="SmsInstruction-phone-to-inner">
                <label
                  htmlFor={inputId}
                  className="SmsInstruction-phone-to-label SmsInstruction-phone-label">
                  To:
                </label>
                <div className="SmsInstruction-phone-to-number">
                  <Input
                    id={inputId}
                    value={number}
                    readOnly
                    className="SmsInstruction-phone-input"
                  />
                </div>
              </div>
            </div>

            <div className="SmsInstruction-phone-message">
              @{code}
              <div className="SmsInstruction-phone-message-bubble-arrow" />
            </div>

            <div className="SmsInstruction-phone-send">Send</div>
          </div>
        </BoxBody>
      </div>
    );
  }
}

export default SmsInstruction;



// WEBPACK FOOTER //
// ./src/users/components/SmsInstruction.jsx